<template>
<!-- 生活直播 -->
  <div class="lifeLive" v-wechat-title="this.title">
    <div class="lifeLiveCon">
      <div  @click.stop="pauses()" v-show="show=='1'" class='stops'></div>
      <div v-show="ishideDiv == '1'" class="cengs" style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:20;background-position: center;background-size: 100% 100%;">
        <div v-show="ishideDiv == '1'" style="position:absolute;left:0;top:0;width:100%;height:100%;background:rgba(0,0,0,0.2);z-index:100;">
          <img @click.stop="playVideo()" src="../../assets/liveplay.png" alt="" style="position:absolute;left:3.04rem;top:40%;width:1.42rem;height:1.42rem;z-index:1111;">
          <!-- <img @click="plays()" v-show="isliving == '2'" src="../../assets/stop.png" alt="" style="position:absolute;left:3.5rem;top:45%;width:0.75rem;height:0.75rem;"> -->
        </div>
      </div>
      <img v-show="stops=='1'" @click.stop="playVideo()" src="../../assets/liveplay.png" alt="" style="position:absolute;left:3.04rem;top:40%;width:1.42rem;height:1.42rem;z-index:1111;">
      <div v-if="is_live=='1'" style="font-size:0.12rem;height:100%;" id='id_test_video'  class="id_test_vide" webkit-playsinline="" playsinline="" x5-playsinline="" x-webkit-airplay="allow"  x5-video-player-type="h5" x5-video-player-fullscreen="" x5-video-orientation="portraint">
     
      </div> 
      <div class="lifeLiveInfo">
        <div class='comperebox'>
          <div class="compereImg">
            <img :src="lifeLiveinfo.avatar" alt="">
          </div>
          <p class="compereName">{{lifeLiveinfo.nickname}}</p>
          <span class='follow'>关注</span>
        </div>
         <!-- 观看人数 -->
        <div class="star">
          <p class="starNumber">
               <span>{{stars_number | peopleNumber}}</span>
               <font v-if="stars_number.length>=5">w</font>
          </p>
        </div>
        <!-- //直播头像 -->
        <div class="compereMsg"  v-if="is_live=='1'">
          <div class="swiper-container swiperlist" id='swiperlist'>
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in avatarlist"  :key="index" style="margin-left:.1rem;">
                <img :src="item.avatar" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- 回放头像 -->
        <!-- <div class="compereMsg"  v-if="is_live=='0'">
          <div class="swiper-container swiperlist" id='swiperlist1'>
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in avatarList"  :key="index" style="margin-right:.1rem;">
                <img :src="item.url" alt="">
              </div>
            </div>
          </div>
        </div> -->
           <!-- <div class="loveGift"  v-if="stars_number>0||stars_number>0">
              <img v-if="stars_number>0" class="love" src="../../assets/heart.png" alt="">
              <span class="fensNum">  
                {{stars_number | peopleNumber}}
               </span>
               <font v-if="stars_number.length>=5">w</font>
              <img v-if="gifts_number>0" class="gift" src="../../assets/gift.png" alt="">
               <span class="giftNum">
                 {{gifts_number | peopleNumber}}
               </span>
               <font v-if="gifts_number.length>=5">w</font>
           </div> -->
      

       </div>
        <div v-if="is_live=='1'" class="types" style="width:1.12rem;height:.4rem;margin-left:.32rem;position:absolute;top:.7rem;z-index:123456;"><img src="../../assets/type1.png" alt="" style="width:1.12rem;height:.4rem;"></div>
        <div v-if="is_live=='0'" class="types" style="width:.96rem;height:.4rem;margin-left:.32rem;position:absolute;top:.7rem;z-index:123456;"><img src="../../assets/type2.png" alt="" style="width:0.96rem;height:.4rem;"></div>
      </div>
      <!-- <span v-if="is_live=='0'" class="timeend"></span>
      <div v-if="is_live=='0'" class="actime"></div> -->
      <!-- <hotRecommendMiddle v-show="recommend.length>0"></hotRecommendMiddle> -->
      <!-- <lifeCommen :lifeProgram="recommend"></lifeCommen> -->
     <myfooter :isFrom="isFrom"></myfooter>  
     <toast></toast>

  </div>
</template>
<script>
  import  myfooter from '../commen/myfooter'
  import cbct from '../../../static/js/base.js'
  import toast from '../commen/toast.vue'
  import share from '../../../static/js/share.js';
  // import lifeCommen from '../commen/lifeCommen.vue'
  // import hotRecommendMiddle from '../commen/hotRecommendMiddle'
  import qs from 'qs'
  import Swiper from 'swiper'
  let connection = navigator.connection||navigator.mozConnection||navigator.webkitConnection||{tyep:'unknown'};
  let type_text = ['unknown','ethernet','wifi','2g','3g','4g','none'];
  export default {
    name: 'lifeLive',
    props: {
    
    },
    data(){
      return {
      hls_url:'',
      lifeLiveinfo:[],
      //  play_id:'',
      type:'',
      number:'',
      isLive:'',
      stars_number:'',
      gifts_number:'',
      autoplay:false,
      live:'',
      isRecorded:'的回放',
      title:"",
      appName:'-听见广播',
      recommend:[],
      ishideDiv:'1',
      //直播头像列表
      avatarlist:[],
      //回放头像列表
      //  avatarList:[
      //       {
      //         url:require('../../assets/avatar1.png'),
      //         index:'1',
      //       },
      //        {
      //         url:require('../../assets/avatar2.png'),
      //         index:'2',
      //       },
      //        {
      //         url:require('../../assets/avatar3.png'),
      //         index:'3',
      //       },
      //        {
      //         url:require('../../assets/avatar4.png'),
      //         index:'4',
      //       },
      //        {
      //         url:require('../../assets/avatar5.png'),
      //         index:'5',
      //       },
      //        {
      //         url:require('../../assets/avatar6.png'),
      //         index:'6',
      //       },
      //        {
      //         url:require('../../assets/avatar7.png'),
      //         index:'7',
      //       },
      //        {
      //         url:require('../../assets/avatar8.png'),
      //         index:'8',
      //       },
      //        {
      //         url:require('../../assets/avatar9.png'),
      //         index:'9',
      //       },
      //        {
      //         url:require('../../assets/avatar10.png'),
      //         index:'10',
      //       },
      //        {
      //         url:require('../../assets/avatar11.png'),
      //         index:'11',
      //       },
      //        {
      //         url:require('../../assets/avatar12.png'),
      //         index:'12',
      //       },
      //        {
      //         url:require('../../assets/avatar13.png'),
      //         index:'13',
      //       },
      //        {
      //         url:require('../../assets/avatar14.png'),
      //         index:'14',
      //       },
      //        {
      //         url:require('../../assets/avatar15.png'),
      //         index:'15',
      //       },
      //        {
      //         url:require('../../assets/avatar16.png'),
      //         index:'16',
      //       },

             
      //  ],
      //1为直播2为回放
      is_live:'',
      stops:'0',
      show:'0',
      timer:'',
      //背景图
      out_image:'',
      // 释放视频播放器
      player1:null, 
      isFrom:{'name':'lifeLive','isLive':'','number':''},
      }
    },
    filters:{
        
      peopleNumber:function(n1){
          if(n1!="") {
            let strNum="";
          if (n1.length>=5) {
            strNum=(parseFloat(n1/10000).toFixed(1))
          }else{
            strNum=n1
          }
            return strNum     
          }
          
      }
    },
  created(){
   let self=this;
   if(self.$route.query.number){
     self.number=self.$route.query.number;
   }
   if(self.$route.query.live_id){
     self.number=self.$route.query.live_id;
     self.$set(self.isFrom,'number',self.$route.query.live_id)
   }

   //回放头像随机排序
  // self.avatarList.sort(function(){return Math.random()>0.5?-1:1;});
   self.type=self.$route.query.type;
   self.isLive=self.$route.query.isLive;
   self.$set(self.isFrom,'isLive',self.$route.query.isLive)
    self.$api.post(cbct.baseurl+"share/live",
    qs.stringify({
     'number':this.number,
     'type':this.type,
   })).then(function(res){
      if (res.c==cbct.code.successCode) {
          if(res.d.info.is_del == '1'){
              self.$router.push({
                path:'delPage'
              })
          }
          
          share.share(self,window.location.href,res.d.live.title,res.d.live.nickname+'正在“听见广播”直播，众多观众强势围观，你还不快来！',res.d.live.image,res.d.live.title);
          share.QQshare(window.location.href,res.d.live.title,res.d.live.nickname+'正在“听见广播”直播，众多观众强势围观，你还不快来！',res.d.live.image);
          self.live=res.d.live;//  后台返回数据  若为空则为录播
          self.lifeLiveinfo=res.d.info;
          self.hls_url=res.d.live.hls_url;
          self.title=res.d.live.title+self.appName;
          self.stars_number=res.d.live.show_spectators;
          self.gifts_number=res.d.live.gifts_number;
          self.avatarlist = res.d.live.person;
          self.is_live = res.d.live.is_live;
          self.out_image = res.d.live.out_image;
          $('.cengs').css('background-image','url('+(res.d.live.out_image)+')');
          self.$nextTick(function () {
              self.swiperbox();
          })
      if(res.d.recommend.length > 0){
          self.recommend=res.d.recommend;
        }else if(res.d.recommend.length == 0){
          self.recommend=['none'];
        }
      if (self.live.is_live == '0') {
        self.$router.push({
         path:'liveStreaming?number='+self.number+'&type='+self.type
       })
     }
         self.player1= new TcPlayer('id_test_video', {
                  "m3u8": self.hls_url,
                  autoplay:false,//iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                  "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                  "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                  flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                  // poster:this.cbct.imgUrlImg()+this.cbct.getCookie('image'),
                  systemFullscreen:false,
                  poster:self.out_image,
                  "wording": {
                      2032: "请求视频失败，请检查网络",
                      2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                  },
                  // 'controls':'none',
                  h5_flv:true,
                  flash:true,
                  live:true,
                  x5_player:true,
                  // x5_type:'h5',
                  // x5_fullscreen:'true',

                  x5_orientation:2,
                  listener:function(msg){
                  $('video').css('object-fit','fill');
                  if (self.live.is_live == '0') {
                    self.$router.push({
                      path:'liveStreaming?number='+self.number+'&type='+self.type
                    })
                  }
            // var b = $(".vcp-timelabel").text(); 
            // $('.actime').html(b);
            // $('.vcp-controls-panel').css('opacity','0','display','none');
            // $('.vcp-controls-panel').css('z-index','1000');
            // $('.vcp-slider-thumb').css({
            //     'background': 'rgba(204, 50, 50, 1) !important',
            // })
            // $('.vcp-slider-track').css({
            //     'background': 'rgba(204, 50, 50, 1) !important',
            // })
            
            // $('.vcp-slider').css({
            //     'background': 'rgba(255, 255, 255, 0.3)',
            // })
          
            // $('.vcp-timeline').css({
            //     'height': '2px',
            //     'margin-left': '1.76rem',
            //     'width': '4rem',
                
            //     'top':'0',
            //     'left': '0',
            //     'height': '10px',
            //     'position': 'absolute',
            //     'z-index': '1001',
            //     'line-height':'1.5em',
            // })
           }
          
         })
        // if(self.is_live=='0'){
        //   self.showtime=false;
        //   //  option.controls='system';
        //   $('.closed').css('display','none');
        //   $('.vcp-timeline').css('display','block');       
        // }
      
        
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
            $('.vcp-fullscreen-toggle').css('display','block');
        }
        if (isIOS) {
            $('.vcp-fullscreen-toggle').css('display','none');
        }  
        // console.log(self.live)
        // if (self.get_status()=='wifi') {//wifi下面自动播放
        //     window.tcplayer.play();
        // }

     
      
       
      }else{
          self.bus.$emit('toast',{show:true,title:res.m})
      } 
   });

  // }


    self.isLives();
      
  },
   methods:{
      get_status(){//判断网络状况
      if(typeof(connection.type) == "number"){
      connection.type_text = type_text[connection.type];
      }else{
      connection.type_text = connection.type;
      }
      if(typeof(connection.bandwidth) == "number"){
      if(connection.bandwidth > 10){
      connection.type = 'wifi';
      }else if(connection.bandwidth > 2){
      connection.type = '3g';
      }else if(connection.bandwidth > 0){
      connection.type = '2g';
      }else if(connection.bandwidth == 0){
      connection.type = 'none';
      }else{
      connection.type = 'unknown';
      }
      }
      if (connection.type_text) {
        return connection.type_text
      }else if(connection.type){
        return connection.type
      }

      
   },
   isLives:function(){
     var self = this;
        self.$api.post(cbct.baseurl+"share/live",
    qs.stringify({
     'number':this.number,
     'type':this.type,
   })).then(function(res){
      if (res.c==cbct.code.successCode) {
          if(res.d.info.is_del == '1'){
              self.$router.push({
                path:'delPage'
              })
          }
          
          share.share(self,window.location.href,res.d.live.title,res.d.live.nickname+'正在“听见广播”直播，众多观众强势围观，你还不快来！',res.d.live.image,res.d.live.title);
          share.QQshare(window.location.href,res.d.live.title,res.d.live.nickname+'正在“听见广播”直播，众多观众强势围观，你还不快来！',res.d.live.image);
          self.live=res.d.live;//  后台返回数据  若为空则为录播
          self.lifeLiveinfo=res.d.info;
          self.hls_url=res.d.live.hls_url;
          self.title=res.d.live.title+self.appName;
          self.stars_number=res.d.live.show_spectators;
          self.gifts_number=res.d.live.gifts_number;
          self.avatarlist = res.d.live.person;
          self.is_live = res.d.live.is_live;
          self.out_image = res.d.live.out_image;
          $('.cengs').css('background-image','url('+(res.d.live.out_image)+')');
          self.$nextTick(function () {
              self.swiperbox();
          })
      if(res.d.recommend.length > 0){
          self.recommend=res.d.recommend;
        }else if(res.d.recommend.length == 0){
          self.recommend=['none'];
        }
      if (self.live.is_live == '0') {
        self.$router.push({
         path:'liveStreaming?number='+self.number+'&type='+self.type
       })
     }
         self.player1= new TcPlayer('id_test_video', {
                  "m3u8": self.hls_url,
                  autoplay:false,//iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                  "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                  "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                  flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                  // poster:this.cbct.imgUrlImg()+this.cbct.getCookie('image'),
                  systemFullscreen:false,
                  poster:self.out_image,
                  "wording": {
                      2032: "请求视频失败，请检查网络",
                      2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                  },
                  // 'controls':'none',
                  h5_flv:true,
                  flash:true,
                  live:true,
                  x5_player:true,
                  // x5_type:'h5',
                  // x5_fullscreen:'true',

                  x5_orientation:2,
                  listener:function(msg){
                  $('video').css('object-fit','fill');
                  if (self.live.is_live == '0') {
                    self.$router.push({
                      path:'liveStreaming?number='+self.number+'&type='+self.type
                    })
                  }         
           }
          
         })
         
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
            $('.vcp-fullscreen-toggle').css('display','block');
        }
        if (isIOS) {
            $('.vcp-fullscreen-toggle').css('display','none');
        }  
      }else{
          self.bus.$emit('toast',{show:true,title:res.m})
      } 
   });

   },
   playVideo:function(){
      $('video')[0].play();
      this.ishideDiv = '0';
      // if(this.is_live=='1'){
        this.stops='0';
        this.show='1';
       
        // $('.vcp-panel-bg').css('opacity','0');
        // $('.vcp-timeline').css('display','none');
        // $('.vcp-timelabel').css('display','none'); 
      // }else{
      //   this.showtime=false;
      //     $('.vcp-timeline').css('display','block')
      //   //  var str=($(".vcp-timelabel").text())
      //   //  var a= str.split('/')[0];
      //   //  var b= str.split('/')[1];
      //     // var a = $(".vcp-timelabel").text().split('/')[1]; 
      //     // $('.timeend').text(a)
      // }
      
   },
 
   swiperbox:function(){
        var swiper = new Swiper('#swiperlist', {
        slidesPerView:3,
        spaceBetween: 10,
        observer:true,
        observeParents:true,
      })
   },
  pauses:function(){
    if(this.is_live=='1'){
      $('video')[0].pause();
      this.stops='1';
      // $('.vcp-controls-panel').css('opacity','0','display','none');
      // $('.vcp-panel-bg').css('display','none');
      // $('.vcp-playtoggle').css('display','none');
    }  
  },
  //  plays:function(){
  //   //  this.ishideDiv = '0';
  //    $('.vcp-controls-panel').css('opacity','1');
  //    $('video')[0].pause();
  //    this.isliving ='1';
  //    var self = this;
  //   //  setTimeout(function(){
  //      self.ishideDiv = '0';
  //   //  },1000)
  //  },
  //  showOrHide:function(){
  //    this.ishideDiv = '1';
  //    var self = this;
  //    setTimeout(function(){
  //      self.ishideDiv = '0';
  //    },2000)
  //  }

  },
  mounted(){
    var self = this;
    this.$refs.setHeight.style.height=document.body.clientHeight-1+'px';
     

      //  var swiper1 = new Swiper('#swiperlist1', {
      //   slidesPerView:'auto',
      //   spaceBetween: 10,
      //   observer:true,
      //   observeParents:true,
      // })
      //  self.timer = setInterval(function() {
      //     if($('.vcp-controls-panel').hasClass("show")){
      //       $('.timeend').show();
      //     }else{
      //         $('.timeend').hide();
      //     }      
            
      //   },300);
     
  },
  //  watch:{
  //     //  解决修改url复用同一个组件不重新加载问题,因为路由相同，vue会认为是同一个页面从而复用已加载的页面，不重新加载
  //     '$route'(to,from){
  //       if (to.name==='liveStreaming') {
  //         //  console.log(to.query);
  //         this.number=to.query.live_id;
  //         this.type=to.query.type;
  //         this.isLive=to.query.isLive; 
  //         if (to.query.isLive=='0') {
  //           this.isPlay();
  //         }else if (to.query.isLive=='1') {
  //             this.isLives();
  //         }
  //       }
  //     }
  //   }, 
  destroyed(){
     if(this.timer != ''){
          clearInterval(this.timer);
        }
  },
  components: {

      myfooter,
      toast,
      // lifeCommen,
      // hotRecommendMiddle
     
    }
}
</script>
<style>
 .vcp-timelabel{
        font-size: 0.24rem;
        font-weight: normal;
        line-height: .92rem;
        height: .92rem;
        padding: 0;
        width: .76rem;
        text-align: left;
    }
    .vcp-panel-bg{
        background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
        background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(0,0,0,0)), color-stop(100%,rgba(0,0,0,0.5)));
        background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
        background: -o-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
        background: -ms-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
        background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
        width:100%;
        height:.92rem;
        /* background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%); */
    }
    .vcp-playtoggle{
      width: .48rem;
      height: .48rem;
      margin: .24rem;
      background-size: 100% 100%;
        /* display: none; */
    }
    .vcp-slider-track{
        background: rgba(204, 50, 50, 1) !important;
    }
    .vcp-slider .vcp-slider-thumb{
        display: block;
        background: rgba(255, 67, 67, 1) !important;
        width: .16rem !important;
        height: .16rem !important;
        border-radius: 50% !important;
        top: -.06rem !important;
    }
    .vcp-slider-track{
        display: block;
        background: rgba(255, 67, 67, 1) !important;
        border-radius: 30%;
    }
    .vcp-slider{
        display: block;
        background: rgba(255, 255, 255, 0.5);
    }
    .vcp-timeline {
        display: block;
        height: .04rem;
        margin-left: 1.76rem;
        width: 4rem;
        top: .52rem;
        /* margin-top: .48rem; */
        left: 0;
        height: .2rem;
        position: absolute;
        z-index: 1001;
        /* line-height:1.5em; */
    }
    .vcp-timeline:hover .vcp-slider {
        /* margin-top: 8px; */
        height: .04rem;
    }
    .vcp-timeline .vcp-slider{
        margin-top: 0;
    }
    /* .vcp-timeline:hover .vcp-slider-thumb{
        display: none;
    } */
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.actime{
  position: absolute;
  bottom: 2rem;
  left:0;
  font-size: .56rem;
  width: 100%;
  text-align: center;
  font-weight: 500;
  color: #fff;
  z-index: 9999;
  text-shadow:0px 1px 2px rgba(0,0,0,0.13);
}
.timeend{
  position: absolute;
  bottom: 1rem;
  right: .9rem;
  display: inline-block;
  height: .92rem;
  line-height: .92rem;
  font-size: .24rem;
  color: #fff;
  z-index: 10;
}
  .lifeLive{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  } 

  .lifeLiveCon{
    position: relative;
    height: 13.34rem;
 
  }
  .id_test_vide{
    width: 100%;
    /* position: absolute; */
    z-index: 10 !important;
    height: 13.34rem;
  }

  .lifeLiveInfo{
    box-sizing: border-box;
    position: absolute;
    left:0;
    height: 1.17rem;
    top: 0;
    z-index: 10000 !important;
    font-size: 0.3rem;
    width: 100%;
    overflow: hidden;
  }
  .comperebox{
    float:left;
    height: .6rem;
    line-height: .6rem;
    background:rgba(0,0,0,.3);
    border-radius: .32rem;
    box-sizing: border-box;
    margin: .3rem 0 0 .32rem;
    overflow: hidden;
  }
  .compereImg{
    height: 0.6rem;
    width: 0.6rem;
    float: left;
  }
  .compereImg img{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  .compereName{
    float: left;
    max-width: 1.2rem;
    height: 0.6rem;
    line-height: 0.6rem;
    margin-left: 0.12rem;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:rgba(255,255,255,1);
  }
  .follow{
    display: inline-block;
    width: .72rem;
    height: .44rem;
    color:#fff;
    border-radius: .24rem;
    background: #FC404A;
    font-size: .24rem;
    text-align: center;
    line-height: .44rem;
    margin:.08rem .14rem 0;
  }
  /* 头像列表 */
  .compereMsg{
    width: 2rem;
    height: .6rem;
    float: right;
    overflow: hidden;
    margin-top: .3rem;
  }
  .swiperlist{
    height: .6rem;
    box-sizing: border-box;
    z-index: 1002;
    text-align: right;
  }
  .swiperlist .swiper-wrapper{
       justify-content: flex-end;
  }
 
  .swiperlist .swiper-slide{
    width:.6rem !important;
    height:.6rem !important;
    margin-right: 0 !important;
    border-radius: 50%;
    box-sizing: border-box;
    float: right;
    border:1px solid rgba(255,255,255,1);
  }
  .swiperlist .swiper-slide img{
    border-radius: 50%;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .star{
    float: right;
    margin: .3rem .32rem 0 .1rem;
    min-width: .6rem;
    height: .6rem;
    line-height: .6rem;
    background: rgba(0,0,0,.394);
    font-size: .2rem;
    color: #fff;
    border-radius: .5rem;
    box-sizing: border-box;
  }
  .starNumber{
    padding: 0 .2rem;
  }


  .loveGift{
    height:0.35rem;
    padding: 0 0.2rem;
    line-height: 0.35rem;
    /* border: solid 1px; */
    background:rgba(0,0,0,0.24);
    border-radius:0.1rem;
    margin:0.14rem 0 0 0.02rem;
    font-size:0.16rem;
    /* font-family:PingFang-SC-Bold; */
    font-weight:bold;
    color:rgba(255,255,255,1);
    opacity:0.85; 
    text-shadow:0rem 0rem 0rem rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
  }
  .loveGift img:first-of-type{
    width:0.26rem;
    height:0.23rem;
    vertical-align: middle;
  }
  .loveGift img:last-of-type{
    width:0.23rem;
    height:0.25rem;
    vertical-align: middle;
  }
  .fensNum{
    margin: 0 0.27rem 0 0.07rem;
  }
  .giftNum{
    margin-left: 0.07rem;
  }
  .vcp-fullscreen-toggle{
    display: none;
  }
  div.vcp-player.touchable{
    z-index: 10 !important;
  }
  .stops{
    width: 100%;
    height: 80%;
    position: absolute;
    background-color: white\0;
    filter: alpha(opacity=0);
    opacity: 0;
    z-index: 1001;
    top: 0;
    left: 0;
  }

</style>
